import {req, reqJson} from './axiosFun';

/**
 * 轮播图片管理
 **/
// 获取列表
export const bannerList = (params) => {
  var url = "/api/banner/list"
  if (params.type != null) {
    url += "?type=" + params.type;
  }
  return reqJson("get", url)
};
//轮播图保存
export const bannerSave = (params) => {
  return reqJson("post", "/api/banner/save", params)
};
//轮播图编辑
export const bannerUpdate = (params) => {
  return reqJson("post", "/api/banner/update", params)
};
//轮播图删除
export const bannerDelete = (params) => {
  return reqJson("post", "/api/banner/delete/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/bannerMG.js